<script setup>

const axios = require('axios');
  
  import { ref } from 'vue'
  let msg = ref("Ready to upload")
  function uploadFeeds () {
    msg.value = "Uploading feeds"
    axios.get(process.env.VUE_APP_API_BASE_URL+'/updateFeeds'
    ).then((response) => {
      console.log(response.data)
      if(response.data.success)
        msg.value = "Uploaded. Feeds will be processed in the next two minutes."
      setTimeout(()=>{
        msg.value = "Ready to upload"
      }, 5000)
    }).catch(error=>{
      // this.displayGlobalMessage('Encountered error (replace product image).')
      console.log(error.message)

    })
  }

   

</script>

<template>
  <a href="https://vendor.turtleking.com">Back to Vendor portal</a>
  <ul class="settings">
    <li>
      
      <button @click="uploadFeeds()">Upload Feeds</button>
      <span>{{ msg }}</span>

    </li>
  </ul>


</template>
<style scoped lang="scss">
  .settings {
    display:block;
    list-style:none;
    li {
      text-align: center;
      display:inline-block;
      width:50%;
      button {
        display:block;
        margin:10px auto;
      }
    }
  }
</style>